import classNames from 'classnames';
import styles from './Chip.module.css';

export const Chip = ({
  active,
  ...props
}: JSX.IntrinsicElements['button'] & { active?: boolean }) => {
  return (
    <button
      className={classNames(styles.container, 'font-body-MdRegular')}
      data-active={active}
      {...props}
    />
  );
};
